import { type RowData, type TableFeature } from "@tanstack/react-table";

export interface ExpandRowTableState {
  expandedRowIds: string[];
}

interface ExpandRowTableOptions<T> {
  onExpandRow?: (row: T) => void;
}

interface ExpandRowRowOptions<T> {
  expandRow: (row: T) => void;
  isRowExpanded: () => boolean;
}

declare module "@tanstack/react-table" {
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface TableState extends ExpandRowTableState {}
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface TableOptionsResolved<TData extends RowData>
    extends ExpandRowTableOptions<TData> {}
  /* eslint-disable-next-line @typescript-eslint/no-empty-interface */
  interface Row<TData extends RowData> extends ExpandRowRowOptions<TData> {}
}

export const ExpandRowFeature: TableFeature = {
  getInitialState: (state): ExpandRowTableState => {
    return {
      expandedRowIds: [],
      ...state,
    };
  },

  createRow: (row, table): void => {
    row.expandRow = (value) => {
      table.options.onExpandRow?.(value);
    };

    row.isRowExpanded = () => {
      return table.getState().expandedRowIds.includes(row.id);
    };
  },
};
